module.exports = __webpack_public_path__ + "img/dinners-club-tarjeta.2add4017.svg";